export default __webpack_public_path__ + "static/media/loop.33b0f64a.svg";